
export const PasswordMixin = {
    methods: {
        //비밀번호 양식 체크
        chkPassword (password)
        {
            var pw = password;
            var num = pw.search(/[0-9]/g);
            var eng = pw.search(/[a-zA-Z]/ig);

            if (pw.length < 8) return '비밀번호를 8자리 이상 입력해주세요.'
            
            if(pw.search(/\s/) != -1) return '비밀번호는 공백없이 입력해 주세요.';
            
            if(num < 0 || eng < 0) return '비밀번호는 영문, 숫자를 혼합하여 입력해주세요';
            
            return false;
        },
    },
};